import React from 'react';

const ImplementationSteps = () => {
  return (
    <>
      {/* Implementing ASI1 */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">Implementing ASI1</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">1</div>
            <h4 className="font-semibold text-gray-800">Scope your use case</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Identify agentic problems to solve or Web3 tasks to automate</li>
            <li>• Define requirements: agent capabilities, performance, and cost</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">2</div>
            <h4 className="font-semibold text-gray-800">Design your integration</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Select ASI1 models and capabilities based on Web3 needs</li>
            <li>• Choose deployment: ASI1 API, cloud, or on-premise</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">3</div>
            <h4 className="font-semibold text-gray-800">Prepare your data</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Identify blockchain data sources and Web3 knowledge bases</li>
            <li>• Clean and structure on-chain data for agent context</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">4</div>
            <h4 className="font-semibold text-gray-800">Develop your prompts</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Create agent prompts and evaluation frameworks</li>
            <li>• Test and refine agentic behaviors iteratively</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">5</div>
            <h4 className="font-semibold text-gray-800">Implement ASI1</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Set up agent environment and Web3 integrations</li>
            <li>• Define human-in-the-loop and safety requirements</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">6</div>
            <h4 className="font-semibold text-gray-800">Test your system</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Conduct red teaming for potential agent misuse</li>
            <li>• A/B test improvements in DeFi environments</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">7</div>
            <h4 className="font-semibold text-gray-800">Deploy to production</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Deploy agents to Web3 production environments</li>
            <li>• Ensure end-to-end agentic workflow operates smoothly</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">8</div>
            <h4 className="font-semibold text-gray-800">Monitor and improve</h4>
          </div>
          <ul className="space-y-1 text-gray-700 text-sm">
            <li>• Monitor agent performance and effectiveness</li>
            <li>• Make ongoing improvements to agentic behaviors</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ImplementationSteps;
